//记得在 src\components\lang\zhLoad.js 里面添加对象
const user= {
  clientId:'应用编码',
  clientName:'应用名称',
  userNo: '系统登录名',
  userName:'用户姓名',
  useStatusDesc: '状态',
  roleName:'角色',
  roleCode: '角色',
  officeTel:'办公电话',
  mobileTel:'手机',
  addr:'地址',
  fax:'传真',
  email:'电子邮件',
  remark:'备注',
  addUser:'新增用户',
  editUser:'修改用户',
  assignRole:'分配角色',
  editPwd:'修改密码',
  resetPwd:'重置密码',
  currentPwd:'旧密码',
  newPwd:'输入新密码',
  enterAgain:'再次输入',
  rdcNo: '发货仓编码',
  destRdcNo: '收货仓编码',
  rdcName: '仓库名称',
  city: '城市',
  address: '地址',
  lng: '经度',
  lat: '纬度',
  activeOff: '是否激活',
  resetBind: '解绑微信',

  carrierShortName: '承运商简称',
  contact: '联系人',
  mobile: '联系电话',
  activeOffs: '是否有效',
  userTypeNo: '用户类型',

  parkCode: '园区编码',
  parkName: '园区名称',
  parkAddr: '园区地址',
  businessTypeNo: '业务类型编码',
  businessTypeName: '业务类型名称',
  businessTypeSubclassNo: '业务子类编码',
  businessTypeSubclassName: '业务子类名称',
  dockAreaNo: '垛口区域编码',
  dockAreaName: '垛口区域名称',
  carrierCode: '承运商编码',
  carrierName: '承运商名称',
  rolerNo: '角色',

  companyCode: '机构编码',
  companyName: '机构名称',
  shipperCode: '货主编码',
  shipperName: '货主名称',
  projectCode: '项目编码',
  projectName: '项目名称',

  counter: '柜台',
  searchCounter: '搜索柜台',
  waitCounter: '待选柜台',
  chooseCounter: '已选柜台',
  isQiyeWxLoginStr: '是否绑定微信',
  employeeId:'员工ID',
  deptName: '部门',
  supplierCode: '供应商编码',
  supplierName: '供应商名称',
  msg:{
    userNo:'请输入用户名',
    userName:"请输入用户昵称",
    userType: '请选择用户类型',
    useStatus: '请选择状态',
    currentPwd:'请输入旧密码',
    newPwd:'请输入新密码',
    enterAgain:'请再次输入新密码',
    inputPwdError:'两次输入密码不同，请重新输入',
    setRoleAllocation:'确认保存么吗？本次操作未勾选角色，继续操作将会删除原有角色！',
    counterMsg: '请输入客户编号或名称',
    unBind: '确认解绑该用户的微信账号？',
    email: '请输入邮箱地址'
  }
};
export default user



// WEBPACK FOOTER //
// ./src/page/auth/user/lang/user.zh.js